window.SB_STORES = [
  {
    "name": "Sharief Bhai - Akshayanagar",
    "state": "Karnataka",
    "city": "Bengaluru",
    "locality": "Akshayanagar",
    "store_code": "Blr_Akn",
    "status": "Live",
    "page_url": "/pages/outlets/sharief-bhai-biryani-akshayanagar-bengaluru",
    "maps_url": "https://maps.app.goo.gl/Fnt8T5RtT5KjfC9o8",
    "lat": 12.87331182,
    "lng": 77.61683326,
    "weekday": "",
    "weekend": "",
    "swiggy": "https://www.swiggy.com/direct/brand/469102?source=swiggy-direct&subSource=facebook",
    "zomato": "https://zomato.onelink.me/xqzv/7ei4gtxv?brand_id=755&ref_id=5479",
    "ownly": "https://ownly.food/app/brand/BR112583",
    "address": "Shop 52, Yelenahalli Main Rd, DLF Newtown, Akshayanagar, Bengaluru, Karnataka 560114",
    "pincode": "560114",
    "phone": "+91 80957 52222",
    "services": [
      "Dine-in",
      "Delivery",
      "Takeaway",
      "Online Ordering",
      "Bulk Biryani Orders",
      "Catering Enquiry"
    ]
  },
  {
    "name": "Sharief Bhai - BTM",
    "state": "Karnataka",
    "city": "Bengaluru",
    "locality": "BTM",
    "store_code": "Blr_Btm",
    "status": "Live",
    "page_url": "/pages/outlets/sharief-bhai-biryani-btm-bengaluru",
    "maps_url": "https://maps.app.goo.gl/Vruoh9ucpmUnbqcw6",
    "lat": 12.91419075,
    "lng": 77.60621717,
    "weekday": "",
    "weekend": "",
    "swiggy": "https://www.swiggy.com/direct/brand/469102?source=swiggy-direct&subSource=facebook",
    "zomato": "https://zomato.onelink.me/xqzv/7ei4gtxv?brand_id=755&ref_id=5479",
    "ownly": "https://ownly.food/app/brand/BR112583",
    "address": "Shop 320, 7th Main Rd, BTM 2nd Stage, BTM Layout, Bengaluru, Karnataka 560076",
    "pincode": "560076",
    "phone": "+91 80957 52222",
    "services": [
      "Dine-in",
      "Delivery",
      "Takeaway",
      "Online Ordering",
      "Bulk Biryani Orders",
      "Catering Enquiry"
    ]
  },
  {
    "name": "Sharief Bhai - Basaveshwara Nagar",
    "state": "Karnataka",
    "city": "Bengaluru",
    "locality": "Basaveshwara Nagar",
    "store_code": "Blr_Bsn",
    "status": "Live",
    "page_url": "/pages/outlets/sharief-bhai-biryani-basaveshwara-nagar-bengaluru",
    "maps_url": "https://maps.app.goo.gl/dnMqLdfiMyoTnHBp7",
    "lat": 12.9869847,
    "lng": 77.53722912,
    "weekday": "",
    "weekend": "",
    "swiggy": "https://www.swiggy.com/direct/brand/469102?source=swiggy-direct&subSource=facebook",
    "zomato": "https://zomato.onelink.me/xqzv/7ei4gtxv?brand_id=755&ref_id=5479",
    "ownly": "https://ownly.food/app/brand/BR112583",
    "address": "Shop D36/1, 80 Feet Ring Rd, beside Mrs Mannequin Fashion Studio, Stage 1, KHB Colony, Basaveshwar Nagar, Bengaluru, Karnataka 560079",
    "pincode": "560079",
    "phone": "+91 80957 52222",
    "services": [
      "Dine-in",
      "Delivery",
      "Takeaway",
      "Online Ordering",
      "Bulk Biryani Orders",
      "Catering Enquiry"
    ]
  },
  {
    "name": "Sharief Bhai - Budigere Cross",
    "state": "Karnataka",
    "city": "Bengaluru",
    "locality": "Budigere Cross",
    "store_code": "Blr_Bug",
    "status": "Live",
    "page_url": "/pages/outlets/sharief-bhai-biryani-budigere-cross-bengaluru",
    "maps_url": "https://maps.app.goo.gl/BZ5XrvokTu36p71c9",
    "lat": 13.05913361,
    "lng": 77.74326665,
    "weekday": "",
    "weekend": "",
    "swiggy": "https://www.swiggy.com/direct/brand/469102?source=swiggy-direct&subSource=facebook",
    "zomato": "https://zomato.onelink.me/xqzv/7ei4gtxv?brand_id=755&ref_id=5479",
    "ownly": "https://ownly.food/app/brand/BR112583",
    "address": "Shop 95/1, 1st Flr, Budigere Rd, Cheemasandra, Bengaluru, Karnataka 560049",
    "pincode": "560049",
    "phone": "+91 80957 52222",
    "services": [
      "Dine-in",
      "Delivery",
      "Takeaway",
      "Online Ordering",
      "Bulk Biryani Orders",
      "Catering Enquiry"
    ]
  },
  {
    "name": "Sharief Bhai - Chandapura",
    "state": "Karnataka",
    "city": "Bengaluru",
    "locality": "Chandapura",
    "store_code": "Blr_Chd",
    "status": "Live",
    "page_url": "/pages/outlets/sharief-bhai-biryani-chandapura-bengaluru",
    "maps_url": "https://maps.app.goo.gl/wirZHPvS9Jhumuk27",
    "lat": 12.78913086,
    "lng": 77.70444175,
    "weekday": "",
    "weekend": "",
    "swiggy": "https://www.swiggy.com/direct/brand/469102?source=swiggy-direct&subSource=facebook",
    "zomato": "https://zomato.onelink.me/xqzv/7ei4gtxv?brand_id=755&ref_id=5479",
    "ownly": "https://ownly.food/app/brand/BR112583",
    "address": "Shop SY 216, Ground, Surya City, Chandapura- Anekal Rd, Suryanagar Phase I, Suryanagar, Bengaluru, Bommasandra, Karnataka 560081",
    "pincode": "560081",
    "phone": "+91 80957 52222",
    "services": [
      "Dine-in",
      "Delivery",
      "Takeaway",
      "Online Ordering",
      "Bulk Biryani Orders",
      "Catering Enquiry"
    ]
  },
  {
    "name": "Sharief Bhai - Devanahalli",
    "state": "Karnataka",
    "city": "Bengaluru",
    "locality": "Devanahalli",
    "store_code": "Blr_Dev",
    "status": "Live",
    "page_url": "/pages/outlets/sharief-bhai-biryani-devanahalli-bengaluru",
    "maps_url": "https://maps.app.goo.gl/ra4KHxamBDB9g4ah9",
    "lat": 13.26469333,
    "lng": 77.71917198,
    "weekday": "",
    "weekend": "",
    "swiggy": "https://www.swiggy.com/direct/brand/469102?source=swiggy-direct&subSource=facebook",
    "zomato": "https://zomato.onelink.me/xqzv/7ei4gtxv?brand_id=755&ref_id=5479",
    "ownly": "https://ownly.food/app/brand/BR112583",
    "address": "1st Flr, Pillappa Arcade, Tadipatri - Bangalore Rd, Parivara Gutta, Devanahalli, Kurubarakunte, Karnataka 562110",
    "pincode": "562110",
    "phone": "+91 80957 52222",
    "services": [
      "Dine-in",
      "Delivery",
      "Takeaway",
      "Online Ordering",
      "Bulk Biryani Orders",
      "Catering Enquiry"
    ]
  },
  {
    "name": "Sharief Bhai - Frazer Town",
    "state": "Karnataka",
    "city": "Bengaluru",
    "locality": "Frazer Town",
    "store_code": "Blr_Frz",
    "status": "Live",
    "page_url": "/pages/outlets/sharief-bhai-biryani-frazer-town-bengaluru",
    "maps_url": "https://maps.app.goo.gl/9wPKUvT1aLqQMu7d6",
    "lat": 12.99803686,
    "lng": 77.61468602,
    "weekday": "",
    "weekend": "",
    "swiggy": "https://www.swiggy.com/direct/brand/469102?source=swiggy-direct&subSource=facebook",
    "zomato": "https://zomato.onelink.me/xqzv/7ei4gtxv?brand_id=755&ref_id=5479",
    "ownly": "https://ownly.food/app/brand/BR112583",
    "address": "Ground & Mezzanine Floor, 16, Mosque Rd, Frazer Town, Bengaluru, Karnataka 560005",
    "pincode": "560005",
    "phone": "+91 80957 52222",
    "services": [
      "Dine-in",
      "Delivery",
      "Takeaway",
      "Online Ordering",
      "Bulk Biryani Orders",
      "Catering Enquiry"
    ]
  },
  {
    "name": "Sharief Bhai - HRBR",
    "state": "Karnataka",
    "city": "Bengaluru",
    "locality": "HRBR",
    "store_code": "Blr_Hrb",
    "status": "Live",
    "page_url": "/pages/outlets/sharief-bhai-biryani-hrbr-bengaluru",
    "maps_url": "https://maps.app.goo.gl/DZjP6LYeLUoYMnSB8",
    "lat": 13.02349264,
    "lng": 77.64016767,
    "weekday": "",
    "weekend": "",
    "swiggy": "https://www.swiggy.com/direct/brand/469102?source=swiggy-direct&subSource=facebook",
    "zomato": "https://zomato.onelink.me/xqzv/7ei4gtxv?brand_id=755&ref_id=5479",
    "ownly": "https://ownly.food/app/brand/BR112583",
    "address": "1, Site, 1-97-3, Shop, 5th Main Rd, HRBR Layout 2nd Block, HRBR Layout, Kalyan Nagar, Bengaluru, Karnataka 560043",
    "pincode": "560043",
    "phone": "+91 80957 52222",
    "services": [
      "Dine-in",
      "Delivery",
      "Takeaway",
      "Online Ordering",
      "Bulk Biryani Orders",
      "Catering Enquiry"
    ]
  },
  {
    "name": "Sharief Bhai - Hennur",
    "state": "Karnataka",
    "city": "Bengaluru",
    "locality": "Hennur",
    "store_code": "Blr_Hen",
    "status": "Live",
    "page_url": "/pages/outlets/sharief-bhai-biryani-hennur-bengaluru",
    "maps_url": "https://maps.app.goo.gl/wfbH8vbMmqdsNiqv7",
    "lat": 13.06254604,
    "lng": 77.64964706,
    "weekday": "",
    "weekend": "",
    "swiggy": "https://www.swiggy.com/direct/brand/469102?source=swiggy-direct&subSource=facebook",
    "zomato": "https://zomato.onelink.me/xqzv/7ei4gtxv?brand_id=755&ref_id=5479",
    "ownly": "https://ownly.food/app/brand/BR112583",
    "address": "1st Floor, ANJINAPPA COMPLEX, 33/3, Hennur Bagalur Main Rd, near Amma's Pastries, near Royal Enfield Showroom, Kothanur, Bengaluru, Karnataka 560077",
    "pincode": "560077",
    "phone": "+91 80957 52222",
    "services": [
      "Dine-in",
      "Delivery",
      "Takeaway",
      "Online Ordering",
      "Bulk Biryani Orders",
      "Catering Enquiry"
    ]
  },
  {
    "name": "Sharief Bhai - Hesaraghatta",
    "state": "Karnataka",
    "city": "Bengaluru",
    "locality": "Hesaraghatta",
    "store_code": "Blr_Hes",
    "status": "Live",
    "page_url": "/pages/outlets/sharief-bhai-biryani-hesaraghatta-bengaluru",
    "maps_url": "https://maps.app.goo.gl/rRi4QJA9G6oFo8jH9",
    "lat": 13.0699173,
    "lng": 77.50391868,
    "weekday": "",
    "weekend": "",
    "swiggy": "https://www.swiggy.com/direct/brand/469102?source=swiggy-direct&subSource=facebook",
    "zomato": "https://zomato.onelink.me/xqzv/7ei4gtxv?brand_id=755&ref_id=5479",
    "ownly": "https://ownly.food/app/brand/BR112583",
    "address": "Shop 43 & 44, Arunodaya Complex, Hesarghatta Rd, Geleyara Balaga Layout, Jalahalli West, Bengaluru, Karnataka 560090",
    "pincode": "560090",
    "phone": "+91 80957 52222",
    "services": [
      "Dine-in",
      "Delivery",
      "Takeaway",
      "Online Ordering",
      "Bulk Biryani Orders",
      "Catering Enquiry"
    ]
  },
  {
    "name": "Sharief Bhai - Indiranagar",
    "state": "Karnataka",
    "city": "Bengaluru",
    "locality": "Indiranagar",
    "store_code": "Blr_Ind",
    "status": "Live",
    "page_url": "/pages/outlets/sharief-bhai-biryani-indiranagar-bengaluru",
    "maps_url": "https://maps.app.goo.gl/bqbk3dc4zpgvdFr48",
    "lat": 12.98141276,
    "lng": 77.63753193,
    "weekday": "",
    "weekend": "",
    "swiggy": "https://www.swiggy.com/direct/brand/469102?source=swiggy-direct&subSource=facebook",
    "zomato": "https://zomato.onelink.me/xqzv/7ei4gtxv?brand_id=755&ref_id=5479",
    "ownly": "https://ownly.food/app/brand/BR112583",
    "address": "Shop 220, 13th Cross Rd, Indira Nagar II Stage, Hoysala Nagar, Indiranagar, Bengaluru, Karnataka 560038",
    "pincode": "560038",
    "phone": "+91 80957 52222",
    "services": [
      "Dine-in",
      "Delivery",
      "Takeaway",
      "Online Ordering",
      "Bulk Biryani Orders",
      "Catering Enquiry"
    ]
  },
  {
    "name": "Sharief Bhai - JP Nagar",
    "state": "Karnataka",
    "city": "Bengaluru",
    "locality": "JP Nagar",
    "store_code": "Blr_Jpn",
    "status": "Live",
    "page_url": "/pages/outlets/sharief-bhai-biryani-jp-nagar-bengaluru",
    "maps_url": "https://maps.app.goo.gl/huxYKSQUHtp7e7X77",
    "lat": 12.89908033,
    "lng": 77.58645307,
    "weekday": "",
    "weekend": "",
    "swiggy": "https://www.swiggy.com/direct/brand/469102?source=swiggy-direct&subSource=facebook",
    "zomato": "https://zomato.onelink.me/xqzv/7ei4gtxv?brand_id=755&ref_id=5479",
    "ownly": "https://ownly.food/app/brand/BR112583",
    "address": "Shop 2, Ground Flr, Building 18, 24th Main Rd, Nagaraja Garden, J P Nagar Phase 5, J. P. Nagar, Bengaluru, Karnataka 560078",
    "pincode": "560078",
    "phone": "+91 80957 52222",
    "services": [
      "Dine-in",
      "Delivery",
      "Takeaway",
      "Online Ordering",
      "Bulk Biryani Orders",
      "Catering Enquiry"
    ]
  },
  {
    "name": "Sharief Bhai - Kanakapura",
    "state": "Karnataka",
    "city": "Bengaluru",
    "locality": "Kanakapura",
    "store_code": "Blr_Kss",
    "status": "Live",
    "page_url": "/pages/outlets/sharief-bhai-biryani-kanakapura-bengaluru",
    "maps_url": "https://maps.app.goo.gl/zvj7Cz61f8HpqrsU7",
    "lat": 12.81993808,
    "lng": 77.52612164,
    "weekday": "",
    "weekend": "",
    "swiggy": "https://www.swiggy.com/direct/brand/469102?source=swiggy-direct&subSource=facebook",
    "zomato": "https://zomato.onelink.me/xqzv/7ei4gtxv?brand_id=755&ref_id=5479",
    "ownly": "https://ownly.food/app/brand/BR112583",
    "address": "Shop 4, Ground Floor, Sy No-192/2, Papparapatti - Somanahalli Rd, Bengaluru, Karnataka 560082",
    "pincode": "560082",
    "phone": "+91 80957 52222",
    "services": [
      "Dine-in",
      "Delivery",
      "Takeaway",
      "Online Ordering",
      "Bulk Biryani Orders",
      "Catering Enquiry"
    ]
  },
  {
    "name": "Sharief Bhai - Kengeri",
    "state": "Karnataka",
    "city": "Bengaluru",
    "locality": "Kengeri",
    "store_code": "Blr_Ken",
    "status": "Live",
    "page_url": "/pages/outlets/sharief-bhai-biryani-kengeri-bengaluru",
    "maps_url": "https://share.google/u3RdTwWewWQ82ksD1",
    "lat": 12.91975383,
    "lng": 77.48399487,
    "weekday": "",
    "weekend": "",
    "swiggy": "https://www.swiggy.com/direct/brand/469102?source=swiggy-direct&subSource=facebook",
    "zomato": "https://zomato.onelink.me/xqzv/7ei4gtxv?brand_id=755&ref_id=5479",
    "ownly": "https://ownly.food/app/brand/BR112583",
    "address": "1st Flr, EBN Plaza, 1st Main Rd, Stage I, Kengeri Satellite Town, Bengaluru, Karnataka 560060",
    "pincode": "560060",
    "phone": "+91 80957 52222",
    "services": [
      "Dine-in",
      "Delivery",
      "Takeaway",
      "Online Ordering",
      "Bulk Biryani Orders",
      "Catering Enquiry"
    ]
  },
  {
    "name": "Sharief Bhai - Koramangala",
    "state": "Karnataka",
    "city": "Bengaluru",
    "locality": "Koramangala",
    "store_code": "Blr_Kml",
    "status": "Live",
    "page_url": "/pages/outlets/sharief-bhai-biryani-koramangala-bengaluru",
    "maps_url": "https://maps.app.goo.gl/pzTUYJvqmPdrrPdD7",
    "lat": 12.93332438,
    "lng": 77.61540379,
    "weekday": "",
    "weekend": "",
    "swiggy": "https://www.swiggy.com/direct/brand/469102?source=swiggy-direct&subSource=facebook",
    "zomato": "https://zomato.onelink.me/xqzv/7ei4gtxv?brand_id=755&ref_id=5479",
    "ownly": "https://ownly.food/app/brand/BR112583",
    "address": "Shop 68, Jyoti Nivas College Rd, 5th Block, Koramangala, Bengaluru, Karnataka 560095",
    "pincode": "560095",
    "phone": "+91 80957 52222",
    "services": [
      "Dine-in",
      "Delivery",
      "Takeaway",
      "Online Ordering",
      "Bulk Biryani Orders",
      "Catering Enquiry"
    ]
  },
  {
    "name": "Sharief Bhai - Marathahalli",
    "state": "Karnataka",
    "city": "Bengaluru",
    "locality": "Marathahalli",
    "store_code": "Blr_Mtl",
    "status": "Live",
    "page_url": "/pages/outlets/sharief-bhai-biryani-marathahalli-bengaluru",
    "maps_url": "https://maps.app.goo.gl/zdsLAQaBs7stHMZV8",
    "lat": 12.94806355,
    "lng": 77.69871432,
    "weekday": "",
    "weekend": "",
    "swiggy": "https://www.swiggy.com/direct/brand/469102?source=swiggy-direct&subSource=facebook",
    "zomato": "https://zomato.onelink.me/xqzv/7ei4gtxv?brand_id=755&ref_id=5479",
    "ownly": "https://ownly.food/app/brand/BR112583",
    "address": "Shop 37, More Megastore, Service Rd, Marathahalli Village, Marathahalli, Bengaluru, Karnataka 560037",
    "pincode": "560037",
    "phone": "+91 80957 52222",
    "services": [
      "Dine-in",
      "Delivery",
      "Takeaway",
      "Online Ordering",
      "Bulk Biryani Orders",
      "Catering Enquiry"
    ]
  },
  {
    "name": "Sharief Bhai - Nagarbhavi",
    "state": "Karnataka",
    "city": "Bengaluru",
    "locality": "Nagarbhavi",
    "store_code": "Blr_Nag",
    "status": "Live",
    "page_url": "/pages/outlets/sharief-bhai-biryani-nagarbhavi-bengaluru",
    "maps_url": "https://maps.app.goo.gl/KGC1rHPfNJHQ4kVG7",
    "lat": 12.97218121,
    "lng": 77.50799648,
    "weekday": "",
    "weekend": "",
    "swiggy": "https://www.swiggy.com/direct/brand/469102?source=swiggy-direct&subSource=facebook",
    "zomato": "https://zomato.onelink.me/xqzv/7ei4gtxv?brand_id=755&ref_id=5479",
    "ownly": "https://ownly.food/app/brand/BR112583",
    "address": "Outer Ring Rd Shop 732, 1st Flr, 11th Block Naagarabhaavi Nagarabhavi, 2nd Stage, Bengaluru-560072, Vijaya Nagara, BBMP, Karnataka 560072",
    "pincode": "560072",
    "phone": "+91 80957 52222",
    "services": [
      "Dine-in",
      "Delivery",
      "Takeaway",
      "Online Ordering",
      "Bulk Biryani Orders",
      "Catering Enquiry"
    ]
  },
  {
    "name": "Sharief Bhai - RT Nagar",
    "state": "Karnataka",
    "city": "Bengaluru",
    "locality": "RT Nagar",
    "store_code": "Blr_Rtn",
    "status": "Live",
    "page_url": "/pages/outlets/sharief-bhai-biryani-rt-nagar-bengaluru",
    "maps_url": "https://maps.app.goo.gl/Wx6TTjmt6hHXtSEw7",
    "lat": 13.01929827,
    "lng": 77.5924211,
    "weekday": "",
    "weekend": "",
    "swiggy": "https://www.swiggy.com/direct/brand/469102?source=swiggy-direct&subSource=facebook",
    "zomato": "https://zomato.onelink.me/xqzv/7ei4gtxv?brand_id=755&ref_id=5479",
    "ownly": "https://ownly.food/app/brand/BR112583",
    "address": "1st Flr, Next Showmax Room, Rabindranath Tagore Nagar Main Rd, 1st Block, Rahmath Nagar, RT Nagar, Bengaluru, Karnataka 560032",
    "pincode": "560032",
    "phone": "+91 80957 52222",
    "services": [
      "Dine-in",
      "Delivery",
      "Takeaway",
      "Online Ordering",
      "Bulk Biryani Orders",
      "Catering Enquiry"
    ]
  },
  {
    "name": "Sharief Bhai - Sahakar Nagar",
    "state": "Karnataka",
    "city": "Bengaluru",
    "locality": "Sahakar Nagar",
    "store_code": "Blr_Sah",
    "status": "Live",
    "page_url": "/pages/outlets/sharief-bhai-biryani-sahakar-nagar-bengaluru",
    "maps_url": "https://maps.app.goo.gl/K8VQ241p28NtMdna8",
    "lat": 13.06352956,
    "lng": 77.59009269,
    "weekday": "",
    "weekend": "",
    "swiggy": "https://www.swiggy.com/direct/brand/469102?source=swiggy-direct&subSource=facebook",
    "zomato": "https://zomato.onelink.me/xqzv/7ei4gtxv?brand_id=755&ref_id=5479",
    "ownly": "https://ownly.food/app/brand/BR112583",
    "address": "No-184, Krv Aracde, 184, 10th Cross F/G Block Rd, Sahakar Nagar, Byatarayanapura, Bengaluru, Karnataka 560092",
    "pincode": "560092",
    "phone": "+91 80957 52222",
    "services": [
      "Dine-in",
      "Delivery",
      "Takeaway",
      "Online Ordering",
      "Bulk Biryani Orders",
      "Catering Enquiry"
    ]
  },
  {
    "name": "Sharief Bhai - Sarjapur",
    "state": "Karnataka",
    "city": "Bengaluru",
    "locality": "Sarjapur",
    "store_code": "Blr_Sjp",
    "status": "Live",
    "page_url": "/pages/outlets/sharief-bhai-biryani-sarjapur-bengaluru",
    "maps_url": "https://maps.app.goo.gl/WRAQEgCo2HfTpjbN6",
    "lat": 12.91942373,
    "lng": 77.66940973,
    "weekday": "",
    "weekend": "",
    "swiggy": "https://www.swiggy.com/direct/brand/469102?source=swiggy-direct&subSource=facebook",
    "zomato": "https://zomato.onelink.me/xqzv/7ei4gtxv?brand_id=755&ref_id=5479",
    "ownly": "https://ownly.food/app/brand/BR112583",
    "address": "Shop 1, 2 & 3, Ambalipura - Sarjapur Rd, opp. Bellundur Police Station, Bellandur, Bengaluru, Karnataka 560102",
    "pincode": "560102",
    "phone": "+91 80957 52222",
    "services": [
      "Dine-in",
      "Delivery",
      "Takeaway",
      "Online Ordering",
      "Bulk Biryani Orders",
      "Catering Enquiry"
    ]
  },
  {
    "name": "Sharief Bhai - Sarjapur New Town",
    "state": "Karnataka",
    "city": "Bengaluru",
    "locality": "Sarjapur New Town",
    "store_code": "Blr_Sjt",
    "status": "Live",
    "page_url": "/pages/outlets/sharief-bhai-biryani-sarjapur-new-town-bengaluru",
    "maps_url": "https://maps.app.goo.gl/WRt9S7YcW7XeskEF7",
    "lat": 12.87662151,
    "lng": 77.76514733,
    "weekday": "",
    "weekend": "",
    "swiggy": "https://www.swiggy.com/direct/brand/469102?source=swiggy-direct&subSource=facebook",
    "zomato": "https://zomato.onelink.me/xqzv/7ei4gtxv?brand_id=755&ref_id=5479",
    "ownly": "https://ownly.food/app/brand/BR112583",
    "address": "Shop 5/4, Rana City Complex, Sarjapur - Marathahalli Rd, opp. to TPC Eternity Drive, Yamare Village, Bengaluru, Karnataka 562125",
    "pincode": "562125",
    "phone": "+91 80957 52222",
    "services": [
      "Dine-in",
      "Delivery",
      "Takeaway",
      "Online Ordering",
      "Bulk Biryani Orders",
      "Catering Enquiry"
    ]
  },
  {
    "name": "Sharief Bhai - Thanisandra",
    "state": "Karnataka",
    "city": "Bengaluru",
    "locality": "Thanisandra",
    "store_code": "Blr_Than",
    "status": "Live",
    "page_url": "/pages/outlets/sharief-bhai-biryani-thanisandra-bengaluru",
    "maps_url": "https://maps.app.goo.gl/u91eC9yijbSNzzUKA",
    "lat": 13.08965511,
    "lng": 77.63544907,
    "weekday": "",
    "weekend": "",
    "swiggy": "https://www.swiggy.com/direct/brand/469102?source=swiggy-direct&subSource=facebook",
    "zomato": "https://zomato.onelink.me/xqzv/7ei4gtxv?brand_id=755&ref_id=5479",
    "ownly": "https://ownly.food/app/brand/BR112583",
    "address": "Thanisandra Main Rd, Bearing 11, Agrahara Badavane, Bengaluru, Karnataka 560064",
    "pincode": "560064",
    "phone": "+91 80957 52222",
    "services": [
      "Dine-in",
      "Delivery",
      "Takeaway",
      "Online Ordering",
      "Bulk Biryani Orders",
      "Catering Enquiry"
    ]
  },
  {
    "name": "Sharief Bhai - Whitefield",
    "state": "Karnataka",
    "city": "Bengaluru",
    "locality": "Whitefield",
    "store_code": "Blr_Wfd",
    "status": "Live",
    "page_url": "/pages/outlets/sharief-bhai-biryani-whitefield-bengaluru",
    "maps_url": "https://maps.app.goo.gl/DvbGWUehkT6LFdEi7",
    "lat": 12.97639729,
    "lng": 77.75184179,
    "weekday": "",
    "weekend": "",
    "swiggy": "https://www.swiggy.com/direct/brand/469102?source=swiggy-direct&subSource=facebook",
    "zomato": "https://zomato.onelink.me/xqzv/7ei4gtxv?brand_id=755&ref_id=5479",
    "ownly": "https://ownly.food/app/brand/BR112583",
    "address": "Ground Flr, Site 2, 987/262, Whitefield Main Rd, Sathya Sai Layout, Whitefield, Bengaluru, Karnataka 560066",
    "pincode": "560066",
    "phone": "+91 80957 52222",
    "services": [
      "Dine-in",
      "Delivery",
      "Takeaway",
      "Online Ordering",
      "Bulk Biryani Orders",
      "Catering Enquiry"
    ]
  },
  {
    "name": "Sharief Bhai - Yelahanka",
    "state": "Karnataka",
    "city": "Bengaluru",
    "locality": "Yelahanka",
    "store_code": "Blr_Yel",
    "status": "Live",
    "page_url": "/pages/outlets/sharief-bhai-biryani-yelahanka-bengaluru",
    "maps_url": "https://maps.app.goo.gl/3ZEBRsofe2HoQ989A",
    "lat": 13.10020202,
    "lng": 77.58040025,
    "weekday": "",
    "weekend": "",
    "swiggy": "https://www.swiggy.com/direct/brand/469102?source=swiggy-direct&subSource=facebook",
    "zomato": "https://zomato.onelink.me/xqzv/7ei4gtxv?brand_id=755&ref_id=5479",
    "ownly": "https://ownly.food/app/brand/BR112583",
    "address": "808, New Town Main Rd, Yelahanka New Town, Bengaluru, Karnataka 560064",
    "pincode": "560064",
    "phone": "+91 80957 52222",
    "services": [
      "Dine-in",
      "Delivery",
      "Takeaway",
      "Online Ordering",
      "Bulk Biryani Orders",
      "Catering Enquiry"
    ]
  },
  {
    "name": "Sharief Bhai - Ashok Nagar",
    "state": "Tamil Nadu",
    "city": "Chennai",
    "locality": "Ashok Nagar",
    "store_code": "Maa_Ask",
    "status": "Live",
    "page_url": "/pages/outlets/sharief-bhai-biryani-ashok-nagar-chennai",
    "maps_url": "https://maps.app.goo.gl/UXA3sYYPBxdbWiFf7",
    "lat": 13.03751115,
    "lng": 80.2122628,
    "weekday": "",
    "weekend": "",
    "swiggy": "https://www.swiggy.com/direct/brand/469102?source=swiggy-direct&subSource=facebook",
    "zomato": "https://zomato.onelink.me/xqzv/7ei4gtxv?brand_id=755&ref_id=5479",
    "ownly": "https://ownly.food/app/brand/BR112583",
    "address": "1st Ave, Raghavareddy Colony, Zaffarkhanpet, Ashok Nagar, Chennai, Greater Chennai, Tamil Nadu 600083",
    "pincode": "600083",
    "phone": "+91 80957 52222",
    "services": [
      "Dine-in",
      "Delivery",
      "Takeaway",
      "Online Ordering",
      "Bulk Biryani Orders",
      "Catering Enquiry"
    ]
  },
  {
    "name": "Sharief Bhai - Maduravoyal",
    "state": "Tamil Nadu",
    "city": "Chennai",
    "locality": "Maduravoyal",
    "store_code": "Maa_Mdy",
    "status": "Live",
    "page_url": "/pages/outlets/sharief-bhai-biryani-maduravoyal-chennai",
    "maps_url": "https://maps.app.goo.gl/Mon5E2mtYcXhuueW9",
    "lat": 13.06751679,
    "lng": 80.1784592,
    "weekday": "",
    "weekend": "",
    "swiggy": "https://www.swiggy.com/direct/brand/469102?source=swiggy-direct&subSource=facebook",
    "zomato": "https://zomato.onelink.me/xqzv/7ei4gtxv?brand_id=755&ref_id=5479",
    "ownly": "https://ownly.food/app/brand/BR112583",
    "address": "Shop 124, Ground Flr, Madras Bombay Trunk Rd, Sentamil Nagar, Maduravoyal, Chennai, Greater Chennai, Tamil Nadu 600095",
    "pincode": "600095",
    "phone": "+91 80957 52222",
    "services": [
      "Dine-in",
      "Delivery",
      "Takeaway",
      "Online Ordering",
      "Bulk Biryani Orders",
      "Catering Enquiry"
    ]
  },
  {
    "name": "Sharief Bhai - Porur",
    "state": "Tamil Nadu",
    "city": "Chennai",
    "locality": "Porur",
    "store_code": "Maa_Por",
    "status": "Live",
    "page_url": "/pages/outlets/sharief-bhai-biryani-porur-chennai",
    "maps_url": "https://share.google/u9TxNpIVJpRYQsjov",
    "lat": 13.01646768,
    "lng": 80.1379132,
    "weekday": "",
    "weekend": "",
    "swiggy": "https://www.swiggy.com/direct/brand/469102?source=swiggy-direct&subSource=facebook",
    "zomato": "https://zomato.onelink.me/xqzv/7ei4gtxv?brand_id=755&ref_id=5479",
    "ownly": "https://ownly.food/app/brand/BR112583",
    "address": "Shop 104 & 1b1, 1st Floor, Jsv towers, Kundrathur Main Rd, Chennai, Mowlivakkam, Tamil Nadu 600128",
    "pincode": "600128",
    "phone": "+91 80957 52222",
    "services": [
      "Dine-in",
      "Delivery",
      "Takeaway",
      "Online Ordering",
      "Bulk Biryani Orders",
      "Catering Enquiry"
    ]
  },
  {
    "name": "Sharief Bhai - Santhome",
    "state": "Tamil Nadu",
    "city": "Chennai",
    "locality": "Santhome",
    "store_code": "Maa_San",
    "status": "Live",
    "page_url": "/pages/outlets/sharief-bhai-biryani-santhome-chennai",
    "maps_url": "https://maps.app.goo.gl/hCeqodp3UepwkBmb7",
    "lat": 13.03618035,
    "lng": 80.27804298,
    "weekday": "",
    "weekend": "",
    "swiggy": "https://www.swiggy.com/direct/brand/469102?source=swiggy-direct&subSource=facebook",
    "zomato": "https://zomato.onelink.me/xqzv/7ei4gtxv?brand_id=755&ref_id=5479",
    "ownly": "https://ownly.food/app/brand/BR112583",
    "address": "Santhome High Rd, Dummingkuppam, Chennai, Greater Chennai, Tamil Nadu 600004",
    "pincode": "600004",
    "phone": "+91 80957 52222",
    "services": [
      "Dine-in",
      "Delivery",
      "Takeaway",
      "Online Ordering",
      "Bulk Biryani Orders",
      "Catering Enquiry"
    ]
  },
  {
    "name": "Sharief Bhai - Velachery",
    "state": "Tamil Nadu",
    "city": "Chennai",
    "locality": "Velachery",
    "store_code": "Maa_Vlc",
    "status": "Live",
    "page_url": "/pages/outlets/sharief-bhai-biryani-velachery-chennai",
    "maps_url": "https://maps.app.goo.gl/n5eZkotyAVWSDT2L6",
    "lat": 12.97745436,
    "lng": 80.2192366,
    "weekday": "",
    "weekend": "",
    "swiggy": "https://www.swiggy.com/direct/brand/469102?source=swiggy-direct&subSource=facebook",
    "zomato": "https://zomato.onelink.me/xqzv/7ei4gtxv?brand_id=755&ref_id=5479",
    "ownly": "https://ownly.food/app/brand/BR112583",
    "address": "Shop 1, Velachery Bypass Rd, Velachery, Chennai, Greater Chennai, Tamil Nadu 600042",
    "pincode": "600042",
    "phone": "+91 80957 52222",
    "services": [
      "Dine-in",
      "Delivery",
      "Takeaway",
      "Online Ordering",
      "Bulk Biryani Orders",
      "Catering Enquiry"
    ]
  },
  {
    "name": "Sharief Bhai - RS Puram",
    "state": "Tamil Nadu",
    "city": "Coimbatore",
    "locality": "RS Puram",
    "store_code": "Cjb_Rsp",
    "status": "Live",
    "page_url": "/pages/outlets/sharief-bhai-biryani-rs-puram-coimbatore",
    "maps_url": "https://maps.app.goo.gl/f7ZN7ssdr4EGBc2e9",
    "lat": 11.010361,
    "lng": 76.951778,
    "weekday": "",
    "weekend": "",
    "swiggy": "https://www.swiggy.com/direct/brand/469102?source=swiggy-direct&subSource=facebook",
    "zomato": "https://zomato.onelink.me/xqzv/7ei4gtxv?brand_id=755&ref_id=5479",
    "ownly": "https://ownly.food/app/brand/BR112583",
    "address": "Site 212, E TV Swamy Rd, R.S. Puram, Coimbatore, Tamil Nadu 641002",
    "pincode": "641002",
    "phone": "+91 80957 52222",
    "services": [
      "Dine-in",
      "Delivery",
      "Takeaway",
      "Online Ordering",
      "Bulk Biryani Orders",
      "Catering Enquiry"
    ]
  },
  {
    "name": "Sharief Bhai - Hassan",
    "state": "Karnataka",
    "city": "Hassan",
    "locality": "Hassan",
    "store_code": "Has_Has",
    "status": "Live",
    "page_url": "/pages/outlets/sharief-bhai-biryani-hassan-hassan",
    "maps_url": "https://maps.app.goo.gl/6geQX4ud8aDBJXKw5",
    "lat": 12.96104666,
    "lng": 76.32976514,
    "weekday": "",
    "weekend": "",
    "swiggy": "https://www.swiggy.com/direct/brand/469102?source=swiggy-direct&subSource=facebook",
    "zomato": "https://zomato.onelink.me/xqzv/7ei4gtxv?brand_id=755&ref_id=5479",
    "ownly": "https://ownly.food/app/brand/BR112583",
    "address": "Shop SY 278/1&2, Bandadka - Bengaluru Rd, Baladare, Karnataka 573225",
    "pincode": "573225",
    "phone": "+91 80957 52222",
    "services": [
      "Dine-in",
      "Delivery",
      "Takeaway",
      "Online Ordering",
      "Bulk Biryani Orders",
      "Catering Enquiry"
    ]
  },
  {
    "name": "Sharief Bhai - Hosur",
    "state": "Tamil Nadu",
    "city": "Hosur",
    "locality": "Hosur",
    "store_code": "Hsu_Hsu",
    "status": "Live",
    "page_url": "/pages/outlets/sharief-bhai-biryani-hosur-hosur",
    "maps_url": "https://maps.app.goo.gl/dQtXM8q6jqzjuzHA7",
    "lat": 12.72488304,
    "lng": 77.81837511,
    "weekday": "",
    "weekend": "",
    "swiggy": "https://www.swiggy.com/direct/brand/469102?source=swiggy-direct&subSource=facebook",
    "zomato": "https://zomato.onelink.me/xqzv/7ei4gtxv?brand_id=755&ref_id=5479",
    "ownly": "https://ownly.food/app/brand/BR112583",
    "address": "Shop 137/1A, Inner Ring Rd, next to Mahalakshmi Tyres, Shanthi Nagar West, Hosur, Tamil Nadu 635109",
    "pincode": "635109",
    "phone": "+91 80957 52222",
    "services": [
      "Dine-in",
      "Delivery",
      "Takeaway",
      "Online Ordering",
      "Bulk Biryani Orders",
      "Catering Enquiry"
    ]
  },
  {
    "name": "Sharief Bhai - Mangalore",
    "state": "Karnataka",
    "city": "Mangalore",
    "locality": "Mangalore",
    "store_code": "Mlr_Mlr",
    "status": "Live",
    "page_url": "/pages/outlets/sharief-bhai-biryani-mangalore-mangalore",
    "maps_url": "https://maps.app.goo.gl/qUzhfgaqdbSoYRcb9",
    "lat": 12.86980492,
    "lng": 74.84557019,
    "weekday": "",
    "weekend": "",
    "swiggy": "https://www.swiggy.com/direct/brand/469102?source=swiggy-direct&subSource=facebook",
    "zomato": "https://zomato.onelink.me/xqzv/7ei4gtxv?brand_id=755&ref_id=5479",
    "ownly": "https://ownly.food/app/brand/BR112583",
    "address": "36-14, Balmatta Rd, Hampankatta, Mangaluru, Karnataka 575001",
    "pincode": "575001",
    "phone": "+91 80957 52222",
    "services": [
      "Dine-in",
      "Delivery",
      "Takeaway",
      "Online Ordering",
      "Bulk Biryani Orders",
      "Catering Enquiry"
    ]
  },
  {
    "name": "Sharief Bhai - Manipal",
    "state": "Karnataka",
    "city": "Manipal",
    "locality": "Manipal",
    "store_code": "Man_Man",
    "status": "Live",
    "page_url": "/pages/outlets/sharief-bhai-biryani-manipal-manipal",
    "maps_url": "https://maps.app.goo.gl/H564CQJqN7rBBL3j7",
    "lat": 13.34823641,
    "lng": 74.78285554,
    "weekday": "",
    "weekend": "",
    "swiggy": "https://www.swiggy.com/direct/brand/469102?source=swiggy-direct&subSource=facebook",
    "zomato": "https://zomato.onelink.me/xqzv/7ei4gtxv?brand_id=755&ref_id=5479",
    "ownly": "https://ownly.food/app/brand/BR112583",
    "address": "Shop G10, Ground Flr, Hotel Central Park, Manipal-Udupi Hwy, Manipal, Udupi, Karnataka 576104",
    "pincode": "576104",
    "phone": "+91 80957 52222",
    "services": [
      "Dine-in",
      "Delivery",
      "Takeaway",
      "Online Ordering",
      "Bulk Biryani Orders",
      "Catering Enquiry"
    ]
  },
  {
    "name": "Sharief Bhai - Mysore",
    "state": "Karnataka",
    "city": "Mysore",
    "locality": "Mysore",
    "store_code": "Myq_Srr",
    "status": "Live",
    "page_url": "/pages/outlets/sharief-bhai-biryani-mysore-mysore",
    "maps_url": "https://maps.app.goo.gl/WR4kJdGdGyr9h26fA",
    "lat": 12.32172283,
    "lng": 76.64616087,
    "weekday": "",
    "weekend": "",
    "swiggy": "https://www.swiggy.com/direct/brand/469102?source=swiggy-direct&subSource=facebook",
    "zomato": "https://zomato.onelink.me/xqzv/7ei4gtxv?brand_id=755&ref_id=5479",
    "ownly": "https://ownly.food/app/brand/BR112583",
    "address": "Shop 11/13, Sayyaji Rao Rd, adjacent to Karnataka State Warehousing Corporation, Medar Block, Yadavagiri, Mysuru, Karnataka 570001",
    "pincode": "570001",
    "phone": "+91 80957 52222",
    "services": [
      "Dine-in",
      "Delivery",
      "Takeaway",
      "Online Ordering",
      "Bulk Biryani Orders",
      "Catering Enquiry"
    ]
  },
  {
    "name": "Sharief Bhai - Palakkad",
    "state": "Kerala",
    "city": "Palakkad",
    "locality": "Palakkad",
    "store_code": "Pal_Pal",
    "status": "Live",
    "page_url": "/pages/outlets/sharief-bhai-biryani-palakkad-palakkad",
    "maps_url": "https://maps.app.goo.gl/tg4uUERTjoEpfjnAA",
    "lat": 10.76604152,
    "lng": 76.65998532,
    "weekday": "",
    "weekend": "",
    "swiggy": "https://www.swiggy.com/direct/brand/469102?source=swiggy-direct&subSource=facebook",
    "zomato": "https://zomato.onelink.me/xqzv/7ei4gtxv?brand_id=755&ref_id=5479",
    "ownly": "https://ownly.food/app/brand/BR112583",
    "address": "Coimbatore Rd White House Kunnathuremdu, Palakkad - Coimbatore Rd, Selvapalayam, Palakkad, Kerala 678013",
    "pincode": "678103",
    "phone": "+91 80957 52222",
    "services": [
      "Dine-in",
      "Delivery",
      "Takeaway",
      "Online Ordering",
      "Bulk Biryani Orders",
      "Catering Enquiry"
    ]
  },
  {
    "name": "Sharief Bhai - Pondicherry",
    "state": "Tamil Nadu",
    "city": "Pondicherry",
    "locality": "Pondicherry",
    "store_code": "Pon_Pon",
    "status": "Live",
    "page_url": "/pages/outlets/sharief-bhai-biryani-pondicherry-pondicherry",
    "maps_url": "https://maps.app.goo.gl/FRYTnKhDrEq6BEe79",
    "lat": 11.93438144,
    "lng": 79.80722722,
    "weekday": "",
    "weekend": "",
    "swiggy": "https://www.swiggy.com/direct/brand/469102?source=swiggy-direct&subSource=facebook",
    "zomato": "https://zomato.onelink.me/xqzv/7ei4gtxv?brand_id=755&ref_id=5479",
    "ownly": "https://ownly.food/app/brand/BR112583",
    "address": "Ground Floor, 82, 100 Feet Rd, Ellaipillaichavady, Urban, Puducherry, 605005",
    "pincode": "605005",
    "phone": "+91 80957 52222",
    "services": [
      "Dine-in",
      "Delivery",
      "Takeaway",
      "Online Ordering",
      "Bulk Biryani Orders",
      "Catering Enquiry"
    ]
  },
  {
    "name": "Sharief Bhai - Tumkur",
    "state": "Karnataka",
    "city": "Tumkur",
    "locality": "Tumkur",
    "store_code": "Tum_Tum",
    "status": "Live",
    "page_url": "/pages/outlets/sharief-bhai-biryani-tumkur-tumkur",
    "maps_url": "https://maps.app.goo.gl/fyy6eSMvxuyXnZNp6",
    "lat": 13.33392966,
    "lng": 77.12437637,
    "weekday": "",
    "weekend": "",
    "swiggy": "https://www.swiggy.com/direct/brand/469102?source=swiggy-direct&subSource=facebook",
    "zomato": "https://zomato.onelink.me/xqzv/7ei4gtxv?brand_id=755&ref_id=5479",
    "ownly": "https://ownly.food/app/brand/BR112583",
    "address": "Bangalore - Honnavar Hwy, near Sri Lakshmi Timber, Vidyanagar, Tumakur, Karnataka 572103",
    "pincode": "572103",
    "phone": "+91 80957 52222",
    "services": [
      "Dine-in",
      "Delivery",
      "Takeaway",
      "Online Ordering",
      "Bulk Biryani Orders",
      "Catering Enquiry"
    ]
  }
];
